import styled from 'styled-components';

export default styled.div`
  width: 86px;
  height: 1px;
  border-top: 1px solid ${props => props.theme.textLight};
`;
